import React, { forwardRef, useEffect, useState } from "react";
import dayjs from "dayjs";
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import { header, resume } from "../../config/imagesLink";
import QRCode from "react-qr-code";
import PinDropSharpIcon from '@mui/icons-material/PinDropSharp';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import DownloadSharpIcon from '@mui/icons-material/DownloadSharp';
import PlaceSharpIcon from '@mui/icons-material/PlaceSharp';
import MyLocationSharpIcon from '@mui/icons-material/MyLocationSharp';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import SupervisedUserCircleSharpIcon from '@mui/icons-material/SupervisedUserCircleSharp';
import WorkspacePremiumSharpIcon from '@mui/icons-material/WorkspacePremiumSharp';
import MilitaryTechSharpIcon from '@mui/icons-material/MilitaryTechSharp';
import PsychologySharpIcon from '@mui/icons-material/PsychologySharp';
import AttachFileSharpIcon from '@mui/icons-material/AttachFileSharp';
import PersonSharpIcon from '@mui/icons-material/PersonSharp';
import PhoneIphoneSharpIcon from '@mui/icons-material/PhoneIphoneSharp';
import SummarizeSharpIcon from '@mui/icons-material/SummarizeSharp';
import TitleSharpIcon from '@mui/icons-material/TitleSharp';
import SubtitlesSharpIcon from '@mui/icons-material/SubtitlesSharp';
import { ViewResumeSkeleton } from "@skeleton";
import { color } from "framer-motion";
import { useTranslation } from "react-i18next";
import { getVisibleResumeItems } from "../../utility/profileVisibility";


const ResumePdf = forwardRef(({
    ccvInfo,
    ccvEducation,
    ccvCertification,
    ccvAward,
    ccvExperience,
    CCVAttachement,
    skills,
    UserId,
    isLoading
}, ref) => {
   
    const { t } = useTranslation();
    const visibleEducation = getVisibleResumeItems(ccvEducation);
    const visibleExperience = getVisibleResumeItems(ccvExperience)?.filter(
        (item) => !item.isDeleted,
    );
    const visibleCertification = getVisibleResumeItems(ccvCertification);
    const visibleAwards = getVisibleResumeItems(ccvAward);
    const visibleSkills = getVisibleResumeItems(skills);
    const visibleAttachments = getVisibleResumeItems(CCVAttachement);

    return (
        <div
            id="pdfContent"
            ref={ref}
            style={{ 
                overflow: "visible", 
                backgroundColor: "white", 
                boxSizing: "border-box",
                fontFamily: "PlusJakartaSans-Regular", 
                display: "block", 
                marginBottom3:"30px"
            }} 

        >
            {
                isLoading || ccvInfo === "" ? (
                    <ViewResumeSkeleton />
                ) : (
                    <div className="user-resume UpdateProfile">

                      <section style={{ pageBreakBefore: "always" }} className="pdf-section">

                        <div className="resume-header d-flex align-items-center px-3 py-3">
                            <div className="resume-profile-image">
                                <img src={ccvInfo?.userImage} alt="" srcSet="" height={{}} />
                            </div>
                            <div className="resumeHeader ms-3">
                                <h3>{ccvInfo?.fullName}</h3>
                                <div className="uid">
                                    <span className="activeIcon"></span>
                                    <h4 className="ms-3 mb-0">{ccvInfo?.userUid}</h4>
                                </div>
                            </div>
                            <div
                                className="d-flex ms-auto align-items-center"
                                style={{ gap: "10px", flexShrink: 0 }}
                            >
                                <div className="resume-logo weLinkImage d-flex align-items-center">
                                    <img src={header.WeLinkWhite} alt="" srcSet="" />
                                </div>
                                <div
                                    className="pdf-qr-code"
                                    style={{
                                        width: "54px",
                                        height: "54px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "2px solid #ffffff",
                                        backgroundColor: "#ffffff",
                                        flexShrink: 0,
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <QRCode
                                        value={`https://welinkjobs.com/Resume/${UserId}`}
                                        size={50}
                                        level="M"
                                        bgColor="#FFFFFF"
                                        fgColor="#000000"
                                    />
                                </div>
                            </div>
                         </div>

                        {(ccvEducation.length === 0 || ccvExperience.length === 0) && (
                            <p className="warningText"> Warning: Incomplete Resume.</p>
                        )}
                        {/* <div className="row border-custom2 mt-2"> */}
                            {/* <div className="col-md-6">
                                {ccvInfo?.fullName &&
                                    <div
                                        className={`analytic-sub mt-2 mb-1  pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <PersonSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                        Full Name
                                                    </p>
                                                </div>
                                                <p className="ms-1 f-12">
                                                    {ccvInfo?.fullName}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div> */}
                            
                        {/* </div> */}
                        <div className="row border-custom2">
                          {ccvInfo?.title &&
                            <div className="col-md-6 border-custom">
                                    <div
                                        className={`analytic-sub mt-2 mb-1  pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <SubtitlesSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                        Title
                                                    </p>
                                                </div>
                                                <p className="ms-4 f-12">
                                                    {ccvInfo?.title}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                         }
                          {ccvInfo?.email &&
                             <div className="col-md-6 border-custom">
                                    <div
                                        className={`analytic-sub mt-2 mb-1  pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <MailOutlineSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                        {t("User Profile.Email")}
                                                    </p>
                                                </div>
                                                <p className="ms-4 f-12">
                                                    {ccvInfo?.email}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                          }
                          
                          {ccvInfo?.dob &&
                            <div className="col-md-6 border-custom">
                                    <div
                                        className={`analytic-sub mt-2 mb-1 pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <CalendarMonthSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                       {t("User Profile.DOB")}
                                                    </p>
                                                </div>
                                                <p className="ms-4 f-12">
                                                    {ccvInfo?.dob ? dayjs(ccvInfo?.dob).format("DD MMM YYYY") : ""}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                         }
                          {ccvInfo?.nationalityCountry &&
                            <div className="col-md-6 border-custom">
                                    <div
                                        className={`analytic-sub mt-2 mb-1 pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <MyLocationSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                        {t("User Profile.Nationality (Country)")}
                                                    </p>
                                                </div>
                                                <p className="ms-4 f-12">
                                                    {ccvInfo?.nationalityCountry}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                          }
                          {ccvInfo?.currentCity &&
                            <div className="col-md-6 border-custom">
                                    <div
                                        className={`analytic-sub mt-2 mb-1 pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <MyLocationSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                        {t("User Profile.City")}
                                                    </p>
                                                </div>
                                                <p className="ms-4 f-12">
                                                    {ccvInfo?.currentCity}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                          }
                           
                           {ccvInfo?.phoneNumber &&
                             <div className="col-md-6 border-custom">
                                    <div
                                        className={`analytic-sub mt-2 mb-1 pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <PhoneIphoneSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                        {t("User Profile.Phone Number")}
                                                    </p>
                                                </div>
                                                <p className="ms-4 f-12">
                                                  {ccvInfo.phoneCode}-{ccvInfo?.phoneNumber}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            }
                            {ccvInfo?.webSiteLink &&
                            <div className="col-md-6 border-custom">
                                    <div
                                        className={`analytic-sub mt-2 mb-1 pb-3`}
                                    >
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ms-2">
                                                <div className="d-flex verified">
                                                    <LanguageSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                        {t("User Profile.Website")}
                                                    </p>
                                                </div>
                                                
                                            <p className="ms-4 f-14 fw-bold "> 
                                                <a
                                                    className="ms-4 f-12"
                                                    href={
                                                        ccvInfo?.webSiteLink?.startsWith('http://') || ccvInfo?.webSiteLink?.startsWith('https://')
                                                            ? ccvInfo?.webSiteLink
                                                            : `http://${ccvInfo?.webSiteLink}`
                                                    }
                                                    target="_blank"
                                                    class="website-link"
                                                    rel="noopener noreferrer"
                                                >
                                                    {ccvInfo?.webSiteLink}
                                                </a>
                                              </p>
                                            </div>

                                        </div>
                                    </div>
                            </div>  
                            }
                          
                        </div>
                        {ccvInfo?.summary &&
                            <div
                                className={`analytic-sub mt-2 mb-1 pb-3`}
                            >
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="ms-2">
                                        <div className="d-flex verified">
                                            <SummarizeSharpIcon className="HeadingIcon material-symbols-sharp" />
                                            <p className="f-14 ms-1 pb-1 fw-bold me-2">
                                                 {t("User Profile.Summary")}
                                            </p>
                                        </div>

                                        <p className="ms-1 f-12 me-1" style={{textAlign:"justify"}}>
                                            {ccvInfo?.summary}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        }
                      </section>

                      {ccvEducation && visibleEducation.length > 0 && (
                        <section className="pdf-section avoid-break pe-3 ps-3 "> 
                             <div className="d-flex justify-content-center mb-1 mt-2 bordertop-custom2 border-custom2 pb-2">
                                    <div className="d-flex mt-2" >
                                        <SchoolOutlinedIcon className="HeadingIcon material-symbols-sharp" />
                                        <p className="f-16 fw-bold ms-1">{t("User Profile.Education")}</p>
                                    </div>
                                </div>
                        </section>
                        )} 
                           {visibleEducation.map((item, index) => { 
                                            const isLastItem = index === visibleEducation.length - 1;
                                            return (
                                                <div
                                                    className={`page-break analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom"
                                                        } pb-3 ${item?.status === 0 ? 'disableText' : ''}` }
                                                    key={index}>
                                                    <section
                                                        className={`pdf-section avoid-break pe-3 ps-3 ${
                                                                index !== 0 ? "bordertop-custom pt-2 pe-3 ps-3" : "pe-3 ps-3"
                                                            }`}   >
                                                            <div className="d-flex align-items-start justify-content-between">
                                                                <div className="ms-2">
                                                                    <div className="d-flex verified">
                                                                    <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                                                        <p className="f-14 ms-1 fw-bold me-2">
                                                                            {item.institutionName && (
                                                                                <>
                                                                                    {item.institutionName} 
                                                                                </>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                    <div className="d-flex">
                                                                        {item.field && <p className="ms-1 me-1 f-14 fw-bold">{t("User Profile.Field")}: {item.field}</p>}
                                                                        {item.field && <div className="dot"></div>}
                                                                        {item.degree && <p className="ms-2 f-14 fw-bold">{item.degree}</p>}
                                                                    </div>
                                                                    {item.activities && <p className="ms-1 me-1 f-14 ">{t("User Profile.Activity")}: {item.activities}</p>}
                                                                    {item.grade && <p className="ms-1 me-1 f-14">{t("User Profile.Grade")}: {item.grade}</p>}
                                                                    {item.description && <p className="f-12 fst-italic">{item.description}</p>}
                                                                    <div className="d-flex align-items-center">
                                                                        {item.cityName && (
                                                                            <>
                                                                                <PlaceSharpIcon className="material-symbols-sharp locationIcon" />
                                                                                <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                                                                <div className="dot"></div>
                                                                                <p className="ms-2 f-12">
                                                                                    ({dayjs(item.startYear).format("DD MMM YYYY")} - {item.isPresent === true ? "Present" : dayjs(item.endYear).format("DD MMM YYYY")})
                                                                                                                                                            </p>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </section>
                                                </div>
                                            );
                             })} 
               
                    {visibleExperience?.length > 0 && (
                        <section className="pdf-section avoid-break pe-3 ps-3 "> 
                             <div className="d-flex justify-content-center mb-1 mt-2 bordertop-custom2 border-custom2 pb-2">
                                    <div className="d-flex mt-2" >
                                        <BusinessCenterOutlinedIcon className="HeadingIcon material-symbols-sharp" />
                                        <p className="f-16 fw-bold ms-1">{t("User Profile.Experience")}</p>
                                    </div>
                                </div>
                        </section>
                        )}
                    {visibleExperience?.map((item, index, arr) => {
                        const isLastItem = index === arr.length - 1;

                        return (
                        <div
                            key={index} 
                            className="pe-3 ps-3"
                         > 
                            <section
                            className={`pdf-section avoid-break pe-3 ps-3 ${
                                    index !== 0 ? "bordertop-custom pt-2 pe-3 ps-3" : "pe-3 ps-3"
                                }`}  
                            >
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="ms-2">
                                    <div className="d-flex verified">
                                     <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                        <p className="f-14 ms-1 fw-bold me-2">{item.jobTitle}</p>
                                    </div>
                                    {item.companyName && (
                                        <p className="ms-1 me-1 f-14 fw-bold">{item.companyName}</p>
                                    )}
                                    <div className="d-flex align-items-center">
                                        {item.jobTypeName && (
                                        <p className="ms-1 me-2 f-12">{item.jobTypeName}</p>
                                        )}
                                        {item.cityName && (
                                        <>
                                            <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                                            <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                            <div className="dot"></div>
                                            <p className="ms-2 f-12">
                                            ({dayjs(item.startDate).format("DD MMM YYYY")} -{" "}
                                            {item.isPresent ? "Present" : dayjs(item.endDate).format("DD MMM YYYY")})
                                            </p>
                                        </>
                                        )}
                                    </div>
                                    {item.positionHeadline && <p className="f-12">{item.positionHeadline}</p>}
                                    {item.description && <p className="f-12 fst-italic">{item.description}</p>}
                                    </div>
                                </div>
                            </section>
 
                            {item.rsmExperienceAchievements?.filter(a => !a.isDeleted).length > 0 && (
                                <section className="pdf-section avoid-break mt-3 pe-3 ps-3">
                                    <div className="d-flex justify-content-between border-custo">
                                    <div className="d-flex mb-1">
                                        <EmojiEventsOutlinedIcon
                                        className="HeadingIcon material-symbols-sharp"
                                        style={{ marginTop: '1px' }}
                                        />
                                        <h6 className="f-14 ms-1 mb-0 f-600 mt-1">
                                            {t("User Profile.Experience Achievement")}</h6>
                                    </div>
                                    </div>

                                    {item.rsmExperienceAchievements
                                    .filter(a => !a.isDeleted)
                                    .map((ach, idx, arr) => {
                                        const isLastItem = idx === arr.length - 1; // Declared inside map, where `arr` exists
                                        return (
                                        <div key={idx} className="d-flex align-items-start justify-content-between mt-1">
                                            <div className="ms-2">
                                            <div className="d-flex verified">
                                                <p className="f-16 me-1">{idx + 1}.</p>
                                                <p className="f-14 ms-1 me-2 m-0">
                                                {ach.achievement}
                                                <span className="f-12 text-dark ms-1">
                                                    {ach.achivementDate
                                                    ? `(${dayjs(ach.achivementDate).format("DD MMM YYYY")})`
                                                    : ""}
                                                </span>
                                                </p>
                                            </div>
                                            </div>
                                        </div>
                                        );
                                    })}
                                </section>
                                )}

 
                            {item.rsmExperienceRoles?.filter(r => !r.isDeleted).length > 0 && (
                            <section className="pdf-section avoid-break mt-3 pe-3 ps-3">
                                <div className="d-flex justify-content-between border-custo">
                                <div className="d-flex mb-1">
                                    <SupervisedUserCircleSharpIcon className="HeadingIcon material-symbols-sharp" style={{ marginTop: '1px' }} />
                                    <h6 className="f-14 ms-1 mb-0 f-600 mt-1">{t("User Profile.Responsibilities")}</h6>
                                </div>
                                </div>

                                {item.rsmExperienceRoles
                                .filter(r => !r.isDeleted)
                                .map((role, idx) => {
                                        const isLastItem = idx === arr.length - 1; // Declared inside map, where `arr` exists
                                    return(
                                            <div key={idx} className="d-flex align-items-start justify-content-between mt-1">
                                                  <div className="ms-2">
                                                    <div className="d-flex verified">
                                                    <p className="f-16 me-1">{idx + 1}.</p>
                                                    <p className="f-14 ms-1 me-2 m-0">
                                                        {role.role}
                                                    </p>
                                                    </div>
                                                 </div>
                                            </div>
                                          )
                                      }
                                )}
                            </section>
                            )}

                        </div>
                        );
                    })}

                      {/* <section style={{ pageBreakBefore: "always" }} className="pdf-section">
                        {ccvCertification.length === 0 ? '' :
                            <div className="UpdateProfile pb-0 p-3 ">
                                <div className="d-flex justify-content-center mb-1 mt-2 border-custom2 bordertop-custom2 pb-2">
                                    <div className="d-flex mt-2" >
                                        <WorkspacePremiumSharpIcon className="HeadingIcon material-symbols-sharp" />
                                        <p className="f-16 fw-bold ms-1">Certification</p>
                                    </div>
                                </div>  */}
                                {visibleCertification.length > 0 && (
                                    <section className="pdf-section avoid-break pe-3 ps-3 "> 
                                        <div className="d-flex justify-content-center mb-1 mt-2 bordertop-custom2 border-custom2 pb-2">
                                                <div className="d-flex mt-2" >
                                                    <WorkspacePremiumSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-16 fw-bold ms-1">{t("User Profile.Certification")}</p>
                                                </div>
                                            </div>
                                    </section>
                                    )}
                                {visibleCertification.map((item, index) => { 
                                            const isLastItem = index === visibleCertification.length - 1;
                                            return (

                                                <div
                                                    className={`page-break analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom"
                                                        } pb-3 ${item?.status === 0 ? 'disableText' : ''}`} >
                                                    <section
                                                        className={`pdf-section avoid-break pe-3 ps-3 ${
                                                        index !== 0 ? "bordertop-custom pt-2 pe-3 ps-3" : "pe-3 ps-3"
                                                      }`}  >
                                                        <div className="d-flex align-items-start justify-content-between">
                                                            {/* <img src={NewsFeed.companyLogo} alt="" width={40} height={40} /> */}
                                                            <div className="ms-2">
                                                                <div className="d-flex verified">
                                                                <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                                                    <p className="f-14 ms-1 fw-bold me-2">
                                                                        {item.name && (
                                                                            <>
                                                                                {item.name}
                                                                            </>
                                                                        )}
                                                                    </p>
                                                                </div>
                                                                {item.orgName && <p className="ms-1 me-1 f-14 fw-bold">{item.orgName}</p>}
                                                                <div className="d-flex align-items-center">
                                                                    {item.recognition && <p className="ms-1 me-1 f-12">{item.recognition}</p>}
                                                                    {item.credentialId && (
                                                                        <>
                                                                            <div className="dot"></div>
                                                                            <p className="ms-2 f-12">ID: {item.credentialId}</p>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                <div className="d-flex align-items-center">
                                                                    {item.cityName && (
                                                                        <>
                                                                            <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                                                                            <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                                                            <div className="dot"></div>
                                                                            <p className="ms-2 f-12">
                                                                            {item.issueDate === null ? "" : <>
                                                                                ({dayjs(item.issueDate).format("DD MMM YYYY")}
                                                                            </>}  
                                                                            {item.expirationDate === null ? "- Present )" : <> 
                                                                                - {dayjs(item.expirationDate).format("DD MMM YYYY")})
                                                                            </>}  

                                                                            </p>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            );
                                        })}
                            {/* </div>
                        }
                      </section> */}

                               {visibleAwards.length > 0 && (
                                    <section className="pdf-section avoid-break pe-3 ps-3 "> 
                                        <div className="d-flex justify-content-center mb-1 mt-2 bordertop-custom2 border-custom2 pb-2">
                                                <div className="d-flex mt-2" >
                                                    <MilitaryTechSharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-16 fw-bold ms-1">{t("User Profile.Awards")}</p>
                                                </div>
                                            </div>
                                    </section>
                                )}
                      {/* <section style={{ pageBreakBefore: "always" }} className="pdf-section">
                        {ccvAward.length === 0 ? '' :
                            <div className="UpdateProfile pb-0 p-3"> */}
                                {/* <div className="d-flex justify-content-center mb-1 mt-2 bordertop-custom2 border-custom2 pb-2">
                                    <div className="d-flex mt-2" style={{ pageBreakBefore: "always" }}>
                                        <MilitaryTechSharpIcon className="HeadingIcon material-symbols-sharp" />
                                        <p className="f-16 fw-bold ms-1">Awards</p>
                                    </div>
                                </div> */}
                                {visibleAwards.map((item, index) => { 
                                            const isLastItem = index === visibleAwards.length - 1;
                                            return (
                                                <div
                                                    className={`page-break analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom"
                                                        } pb-2 ${item?.status === 0 ? 'disableText' : ''}`}
                                                        
                                                >
                                                     <section
                                                        className={`pdf-section avoid-break pe-3 ps-3 ${
                                                                index !== 0 ? "bordertop-custom pt-2 pe-3 ps-3" : "pe-3 ps-3"
                                                            }`}  
                                                        >
                                                            <div className="d-flex align-items-start justify-content-between">
                                                                {/* <img src={NewsFeed.companyLogo} alt="" width={40} height={40} /> */}
                                                                <div className="ms-2">
                                                                    <div className="d-flex verified">
                                                                        <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                                                        <p className="f-14 ms-1 fw-bold me-2">
                                                                            {item.name && (
                                                                                <>
                                                                                    {item.name}
                                                                                    {/* {item?.isOrgVrfd === true ? (
                                                                                        <img src={resume.verified} width={18} height={18} className="ms-1" />
                                                                                    ) : item?.isOrgRgd === true ? (
                                                                                        <img src={resume.register} width={18} height={18} className="ms-1" />
                                                                                    ) : (
                                                                                        <img src={resume.unregister} width={18} height={18} className="ms-1" />
                                                                                    )}
                                                                                    {item?.isInstitutionDelete && <img src={resume.deleted} width={15} height={15} />} */}
                                                                                </>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                    {item.orgName && <p className="ms-1 me-1 f-14 fw-bold">{item.orgName}</p>}
                                                                    <div className="d-flex align-items-center">
                                                                        {item.recognition && <p className="ms-1 me-1 f-12">{item.recognition}</p>}
                                                                        {item.description && (
                                                                            <>
                                                                                <div className="dot"></div>
                                                                                <p className="ms-2 f-12 fst-italic">{item.description}</p>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    <div className="d-flex align-items-center">
                                                                        {item.cityName && (
                                                                            <>
                                                                                <PlaceSharpIcon className="material-symbols-sharp locationIcon ms-3" />
                                                                                <p className="ms-1 me-1 f-12">{item.cityName}</p>
                                                                                {/* <div className="dot"></div> */}
                                                                            </>
                                                                        )}
                                                                        <p className="ms-2 f-12">
                                                                            ({dayjs(item.issueDate).format("DD MMM YYYY")} - {dayjs(item.expirationDate).format("DD MMM YYYY")})
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </section>
                                                </div>
                                            );
                                        })} 

                               {visibleSkills.length > 0 && (
                                    <section className="pdf-section avoid-break pe-3 ps-3 "> 
                                        <div className="d-flex justify-content-center mb-1 mt-2 bordertop-custom2 border-custom2 pb-2">
                                                <div className="d-flex mt-2" >
                                                    <PsychologySharpIcon className="HeadingIcon material-symbols-sharp" />
                                                    <p className="f-16 fw-bold ms-1">{t("User Profile.Skills")}</p>
                                                </div>
                                            </div>
                                    </section>
                                 )}
                      {/* <section style={{ pageBreakBefore: "always" }} className="pdf-section">
                        {skills.length === 0 ? '' :
                            <div className="UpdateProfile pb-0 p-3 "> */}
                                {/* <div className="d-flex justify-content-center mb-1 mt-2 bordertop-custom2 border-custom2 pb-2">
                                    <div className="d-flex mt-2"  >
                                        <PsychologySharpIcon className="HeadingIcon material-symbols-sharp" />
                                        <p className="f-16 fw-bold ms-1 ">Skills</p>
                                    </div>
                                </div>  */}
                                {visibleSkills.map((item, index) => {
                                            const isLastItem = index === visibleSkills.length - 1;
                                            return (
                                                <div
                                                    className={`page-break  analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom"
                                                        }  ${item?.status === 0 ? 'disableText' : ''}`}
                                                    key={index} >
                                                    <section
                                                        className={`pdf-section avoid-break pe-3 ps-3 ${
                                                                index !== 0 ? "bordertop-custom pt-2 pe-3 ps-3" : "pe-3 ps-3"
                                                            }`}  
                                                        >
                                                            <div className="d-flex align-items-start justify-content-between">
                                                           
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <div className="d-flex align-items-center verified ">
                                                             <p className="f-16 fw-bold me-1">{index + 1}.</p>
                                                            <p className="f-14 ms-1 pb-0 fw-bold  me-2">
                                                                {item.skillName}
                                                            </p>
                                                        </div>
                                                        {/* )} */}
                                                    </div>
                                                    <p className="ms-1 f-12">
                                                        {item.firmIndustryTypeName}
                                                    </p>
                                                        {item.endorsedCount && <p className="ms-1 f-12">
                                                        
                                                            {item.endorsedCount} {t("User Profile.endorsement")}
                                                    </p>}

                                                   </div>
                                                 </section>
                                                </div>
                                            );
                                        })}
                            {/* </div>
                        }
                      </section> */}
                        {/* {CCVAttachement.length === 0 ? '' :
                            <div className="UpdateProfile pb-0 p-3 page-break">
                                <div className="d-flex justify-content-between mb-2 border-custom2 pb-2" >
                                    <div className="d-flex">
                                        <AttachFileSharpIcon className="HeadingIcon material-symbols" />
                                        <p className="f-16 fw-bold ms-1">Attachement</p>
                                    </div>
                                </div>
                                {CCVAttachement &&
                                    visibleAttachments
                                        ?.map((item, index) => {
                                            const isLastItem = index === CCVAttachement?.length - 1;
                                            return (
                                                <div
                                                    className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom2"
                                                        } pb-3 ${item?.status === 0 ? 'disableText' : ''}`}
                                                    key={index}
                                                >
                                                    <div className="d-flex align-items-start justify-content-between">
                                                        <div className="ms-2">
                                                            <div className="d-flex">
                                                                <p className="f-14 ms-1 pb-1 fw-bold">
                                                                    {item?.docName}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                            </div>
                        } */}
                    </div>
                )
            }
        </div>
    );
});

export default ResumePdf;